import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { ContentFiles } from "../content-files";

const INITIALSTATE = {
  currentLocation: "",
  actualFiles: [],
  filesFiltered: [],
  locations: [],
};

const HOMEDIRECTORY = "Home";
const INITIALSTATEDEEP = {
  name: HOMEDIRECTORY,
  id: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
};
export const BrowserFile = ({
  isFetching,
  files,
  debouncedHandleFilterChange,
  handleCreateFolder,
  handleDeleteFolder,
  handleCreateFile,
  handleDeleteFile,
  handleDownloadFile,
  request,
  setRequest,
  onSortChange,
  order,
  orderBy,
  deep,
  setDeep,
}) => {
  const [locationInfo, setLocationInfo] = useState(INITIALSTATE);
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    setLocationInfo({
      ...locationInfo,
      actualFiles: files,
      locations: [INITIALSTATEDEEP],
    });
  }, [files]);

  const applySearch = (value) => {
    setIsSearching(value);
  };

  const setPreviousLocation = (dir) => {
    if (deep.length > 1) {
      let directories = deep;
      directories = directories.splice(
        0,
        !dir ? deep.length - 1 : deep.indexOf(dir) + 1
      );
      setDeep(directories);
      const { id } = directories[directories.length - 1];
      debouncedHandleFilterChange(id, "id");
    }
  };

  const folderSelected = (folderDetails) => {
    if (folderDetails.isDir) {
      let existFolder = null;
      existFolder = deep.filter(
        (directory) => directory.id === folderDetails.id
      );
      if (!existFolder.length) {
        setDeep([...deep, folderDetails]);
        debouncedHandleFilterChange(folderDetails.id, "id");
      }
    }
  };

  const createFolder = (folderName, isPrivate) => {
    const parentId = deep.length === 1 ? null : deep[deep.length - 1].id;
    handleCreateFolder({ name: folderName, parentId, isPrivate });
  };
  const handleClose = () => {
    setRequest({
      message: "",
      type: 0,
      isFetching: false,
      isError: false,
      done: false,
      severity: "",
    });
  };

  const deleteFolder = (id) => {
    handleDeleteFolder({ parentId: id });
  };

  const createFile = (file, isPrivate) => {
    const parentId = deep.length === 1 ? null : deep[deep.length - 1].id;
    handleCreateFile(file, parentId, isPrivate);
  };
  const deleteFile = (id) => {
    handleDeleteFile({ parentId: id });
  };

  return (
    <>
      <ContentFiles
        handleDownloadFile={handleDownloadFile}
        isSearching={isSearching}
        files={locationInfo.actualFiles}
        folderSelected={folderSelected}
        handleDeleteFolder={deleteFolder}
        handleDeleteFile={deleteFile}
        onSortChange={onSortChange}
        order={order}
        orderBy={orderBy}
        deep={deep}
        applySearch={applySearch}
        isFetching={isFetching}
        debouncedHandleFilterChange={debouncedHandleFilterChange}
        handleCreateFolder={createFolder}
        handleCreateFile={createFile}
        request={request}
        setPreviousLocation={setPreviousLocation}
      />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={request.done && request.message.length}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={request.severity}>
          {request.message}
        </Alert>
      </Snackbar>
    </>
  );
};
BrowserFile.propTypes = {
  files: PropTypes.instanceOf(Object).isRequired,
  request: PropTypes.instanceOf(Object).isRequired,
  setRequest: PropTypes.instanceOf(Object).isRequired,
  debouncedHandleFilterChange: PropTypes.func.isRequired,
  handleCreateFolder: PropTypes.func,
  handleCreateFile: PropTypes.func,
  handleDeleteFolder: PropTypes.func,
  handleDeleteFile: PropTypes.func,
  handleDownloadFile: PropTypes.func,
  isFetching: PropTypes.bool.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  onSortChange: PropTypes.func.isRequired,
  deep: PropTypes.instanceOf(Object).isRequired,
  setDeep: PropTypes.func.isRequired,
};
BrowserFile.defaultProps = {
  handleCreateFolder: (f) => f,
  handleCreateFile: (f) => f,
  handleDeleteFolder: (f) => f,
  handleDeleteFile: (f) => f,
  handleDownloadFile: "",
};
